<template>
<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-BiDeng`]" width="1em" height="1em" v-bind="$attrs"><rect x="4.011" y="14.8" width="1.67" height="8.552" rx=".835" :fill="useCurrentColor ? 'currentColor' : '#000'"/><rect x="14.293" y="14.188" width="1.67" height="4.594" rx=".835" :fill="useCurrentColor ? 'currentColor' : '#000'"/><rect x="4.846" y="18.782" width="1.67" height="11.117" rx=".835" transform="rotate(-90 4.846 18.782)" :fill="useCurrentColor ? 'currentColor' : '#000'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.3457 2.21216C10.4461 1.63782 10.9448 1.21875 11.5279 1.21875L18.8505 1.21912C19.4386 1.21924 19.9401 1.64551 20.0348 2.22607L21.8581 13.407C21.9775 14.1392 21.4106 14.8031 20.6687 14.8L9.57646 14.7542C8.83311 14.751 8.27135 14.0797 8.39935 13.3475L10.3457 2.21216ZM11.7429 2.87012H18.6026L19.8087 10.0771H10.4634L11.7429 2.87012ZM10.1971 11.5771L9.9172 13.1538H20.3236L20.0597 11.5771H10.1971Z" :fill="useCurrentColor ? 'currentColor' : '#000'"/><path d="M9.91675 13.1689L10.198 11.5635L20.0691 11.5879L20.3269 13.1494L9.91675 13.1689Z" :fill="useCurrentColor ? 'currentColor' : '#DCBFF5'"/></svg>
</template>
<script>

export default {
  name: 'IconBiDeng',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
